import axios from 'axios';

export const newTagsMap = async (tag) => {
  const url = `${process.env.REACT_APP_API_URL}/tags`
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const {data} = await axios.post(url,{...tag},{headers: headers});
    return data;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


